import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { VehicleService } from 'src/app/services/vehicle/vehicle.service';
import { GeneralService } from 'src/app/services/general/general.service';

@Component({
  selector: 'app-proforma-vh-detail',
  templateUrl: './proforma-vh-detail.component.html',
  styleUrls: ['./proforma-vh-detail.component.scss']
})
export class ProformaVhDetailComponent implements OnInit, OnDestroy {

  selectedVehicle: any = null;
  vehicleId: string | null = null;
  isLoading: boolean = false;
  isGeneratingPdf: boolean = false;
  pdfUrl: string = '';
  private subscription: Subscription = new Subscription();

  constructor(
    private _vehicleService: VehicleService,
    private _generalService: GeneralService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.setupModalListener();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_proforma_vh_detail');
    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', () => {
        console.log('Vehicle detail modal opened');
        // Get vehicle ID from window object
        const vehicleId = (window as any).selectedVehicleIdForDetail;
        const proformaId = (window as any).selectedProformaIdForDetail;
        if (vehicleId) {
          this.vehicleId = vehicleId;
          this.loadVehicleDetails(vehicleId,proformaId);
        }
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.resetModal();
      });
    }
  }

  private loadVehicleDetails(vehicleId: string,proformaId:string): void {
    this.isLoading = true;
    this.selectedVehicle = null;

    this.subscription.add(
      this._vehicleService.GetDataById(vehicleId,{order_id:proformaId}).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          console.log('Vehicle data received from API:', response);
          if (response.status && response.data) {
            this.selectedVehicle = response.data;
            console.log('Vehicle details loaded:', this.selectedVehicle);
          } else {
            console.error('Failed to load vehicle details');
          }
          this.cdr.detectChanges();
        },
        error: (error: any) => {
          this.isLoading = false;
          console.error('Error loading vehicle details:', error);
          this.cdr.detectChanges();
        }
      })
    );
  }

  private resetModal(): void {
    this.selectedVehicle = null;
    this.vehicleId = null;
    this.isLoading = false;
    this.pdfUrl = '';
    this.isGeneratingPdf = false;
    (window as any).selectedVehicleIdForDetail = null;
  }

  closeModal(): void {
    const modalElement = document.getElementById('kt_modal_proforma_vh_detail');
    if (modalElement) {
      const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  generatePdf(): void {
    if (!this.selectedVehicle || !this.selectedVehicle._id) {
      console.error('No vehicle selected');
      return;
    }

    this.isGeneratingPdf = true;
    this.pdfUrl = ''; // Clear previous PDF URL

    const data = {
      vehicle_id: this.selectedVehicle._id,
      type: 'vehicle-detail'
    };

    console.log('Generating PDF for vehicle:', data);

    this.subscription.add(
      this._generalService.generatePDF(data).subscribe({
        next: (response: any) => {
          this.isGeneratingPdf = false;
          console.log('PDF generation response:', response);

          if (response && response.data && response.data.url) {
            this.pdfUrl = response.data.url;
            console.log('PDF generated successfully. URL:', this.pdfUrl);
          } else {
            console.error('Invalid response format:', response);
            alert('PDF generated but no URL received. Please try again.');
          }
          this.cdr.detectChanges();
        },
        error: (error: any) => {
          this.isGeneratingPdf = false;
          console.error('Error generating PDF:', error);
          alert('Error generating PDF. Please try again.');
          this.cdr.detectChanges();
        }
      })
    );
  }

  openPdf(): void {
    if (this.pdfUrl) {
      window.open(this.pdfUrl, '_blank');
    } else {
      console.error('No PDF URL available');
    }
  }

  getVehiclePoints(vehicle_key:string): string {

    let accessories = this.selectedVehicle[vehicle_key];

    let result = '';

    if (accessories) {
      result =  Object.keys(accessories).filter(key => accessories[key] === 1).join(', ');
      // @ts-ignore
      result = result.replaceAll(/_/g, ' ');
      // @ts-ignore
      result = result.replaceAll("op", '');
    }

    return result;
  }

  formatDocumentType(type: string): string {
    // Convert snake_case to Title Case
    return type
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  getAllocations(allocations:any, invoice_amount:number){

    if(!allocations) return [];

    let remaining = invoice_amount;

    let i = 0;

    let allocationsArr = allocations.map((allocation: any) => {
      remaining -= allocation.allocate_amount?allocation.allocate_amount:0;
      i++;
      return {
        date : allocation.created_at,
        debit : i <= 1?invoice_amount:'--',
        credit : allocation.allocate_amount,
        balance : remaining
      }


      // return {
      //   ...allocation,
      //   remaining
      // };
    });

   return allocationsArr;

  }

  getTotalAllocated(allocations: any): number {
    return allocations.reduce((sum:any, allocation:any) => sum + allocation.allocate_amount, 0);
  }

}
